export const MIN_LANES = 2;
export const MAX_LANES = 10;
